import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GlobalProvider {

  public regId: any;
  public userId: any;
  public activeSession: any;
  public devicePlatform: any;

  public firstName: any;
  public lastName: any;
  public email: any;
  public userName: any;
  public user: any;

  public novoUsuario: any;
  public editarUsuario: any;

  public table: any;
  public page_title: any;

  public securityLevel: any;
  public level: any;
  public changeSecurity: any;
  public changePassword: any

  public areaAccess: any;
  public notifCheckBox: boolean;
  public function_list: any;

  public operacao: any;

  public card_tag: any;
  public card_full: any;

  public permissions: any[] = []; //Permissões do usuário logado 
  public nome_menu: any[];
  public menu: any;
  public nome_tela: any[];
  public nome_tabela: any[];
  public urls: any[] = [];
  public banco: string;
  public changeClient_enable: boolean = false;

  public password: any;
  public hidePass: any;
  public changeUserPermissions: any;
  public userPermissions: any; //Permissões do usuário selecionado na tele de Usuário
  public setUserPermissions: any;
  public teste: any;

  public notifications: any;
  public userNotifications: any;
  public setUserNotifications: any;
  public hideRoot: any = true;

  public token: any ;
  public rf_token: any ;
  public token_exp : any ;

  public data : Observable<any>;

  check_jwt(){
    let now = Date.now()/1000;
    if (this.token_exp <= now) {
      let body = new FormData();
      body.append('rft', this.rf_token);
      var url = 'http://iot.digicomp.com.br/api/public/ping/refresh';
      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        if (data.login) {
          let jwt=JSON.parse(atob(data.jwt.split(".")[1]));
          this.activeSession = data.login;
          this.securityLevel = jwt.sec;
          this.permissions = [];
          for (let i = 0; i < jwt.per.split(';').length; i++) {
            this.permissions[i] = jwt.per.split(';')[i];
          }
          this.notifications = [];
          for (let i = 0; i < jwt.are.split(';').length; i++) {
            this.notifications[i] = jwt.are.split(';')[i];
          }
          this.token = data.jwt;
          this.rf_token = data.rft;
          this.token_exp = jwt.exp;
          localStorage.setItem('storedrf', this.rf_token);
        }
        else {
          this.activeSession = data.login;
        }
      },
      (err)=>{
        console.log(err);
        document.getElementById("result").textContent = "Erro! Tente novamente mais tarde";
      });
    }
  }

  
  constructor(public http: HttpClient) {

  }

}



// WEBPACK FOOTER //
// ./src/providers/global/global.ts